
import { WidgetDefinition } from "@/components/admin/dashboard/widget-types";

// Helper function to convert data fields to string array
export const convertDataFieldsToStringArray = (dataFields: any): string[] => {
  if (!dataFields) return [];
  
  if (Array.isArray(dataFields)) {
    // Map each item to string, ensuring we handle all types
    return dataFields.map(field => String(field));
  }
  
  // If it's not an array, convert to string and wrap in array
  return [String(dataFields)];
};

// Map database widget entity to application widget definition
export const mapWidgetEntity = (item: any): WidgetDefinition => ({
  id: item.id,
  title: item.title,
  description: item.description || "",
  defaultSize: item.default_size as 'small' | 'medium' | 'large' | 'xlarge',
  chartType: item.chart_type as any,
  dashboardType: item.dashboard_type as any,
  queryName: item.query_name || undefined,
  dataFields: convertDataFieldsToStringArray(item.data_fields),
  isActive: item.is_active,
  customComponent: item.custom_component || undefined,
  createdAt: item.created_at,
  updatedAt: item.updated_at
});
